export function containsForbiddenCharacters(value: string): boolean {
    const regex = new RegExp(/[\^°!"²³[\]{}=´`%&@§$€*~#<>|µ;_]+/);
    return regex.test(value);
}

export function formatIban(iban: string): string {
    const cleanedIban = iban.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

    if (cleanedIban.length !== 22 || !cleanedIban.startsWith('DE')) {
        return iban;
    }

    const countryCode = cleanedIban.slice(0, 2);
    const checkDigits = cleanedIban.slice(2, 4);
    const bankCode = cleanedIban.slice(4, 12);
    const accountNumber = cleanedIban.slice(12, 22);

    const maskedBankCode = bankCode.replace(/./g, 'X');
    const maskedAccountNumber = accountNumber.slice(0, 6).replace(/./g, 'X') +
        accountNumber.slice(6, 8) +
        accountNumber.slice(8);

    const maskedIban = countryCode + checkDigits + maskedBankCode + maskedAccountNumber;

    return maskedIban.match(/.{1,4}/g)?.join(' ') || maskedIban;
}
